var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LocationPicker"},[_c('div',{ref:"map",staticClass:"LocationPicker__map"}),_vm._v(" "),_c('input',{ref:"input",staticClass:"LocationPicker__autocomplete",attrs:{"type":"text"}}),_vm._v(" "),_c('info-window',{ref:"info",staticClass:"LocationPicker__info-window"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }